import React, { useContext } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { AppAuthContext } from '../contexts/AppAuthContext';
import AboutPage from '../pages/AboutPage';
import HomePage from '../pages/HomePage';
import SignInPage from '../pages/SignInPage';
import BolListPage from '../pages/BolListPage';

const AppRouter = () => {
    const { isAuth } = useContext(AppAuthContext);

    return (
        <Switch>
            <Route exact path="/">
                <HomePage />
            </Route>
            <Route path="/about">
                <AboutPage />
            </Route>
            <Route path="/bol">
                {isAuth ? <BolListPage /> : <Redirect to="/" />}
            </Route>
            <Route path="/signin">
                {isAuth ? <Redirect to="/" /> : <SignInPage />}
            </Route>
        </Switch>
    )
}

export default AppRouter;